var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9923 4.52032L12.4646 11.9556C12.3335 12.0698 12.1693 12.1321 11.9999 12.1321C11.8305 12.1321 11.6663 12.0698 11.5353 11.9556L3.0026 4.52032C3.42593 4.18257 3.9408 4 4.46996 4H19.525C20.0541 4 20.569 4.18257 20.9923 4.52032ZM12.0012 13.6935C12.5099 13.6935 13.003 13.506 13.3964 13.163L21.863 5.77967C21.9532 6.05398 21.9995 6.34241 22 6.63299V17.3723C21.9994 18.069 21.7389 18.7369 21.2758 19.2295C20.8127 19.7222 20.1849 19.9992 19.53 19.9999H4.47004C3.81514 19.9992 3.18726 19.7222 2.72417 19.2295C2.26109 18.7369 2.00065 18.069 2 17.3723V6.63299C2.00053 6.34241 2.04682 6.05398 2.13695 5.77967L10.606 13.163C10.9995 13.506 11.4925 13.6935 12.0012 13.6935Z",
    fill: "#EE741F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailYellow);
export default __webpack_public_path__ + "static/media/email-yellow.58d23d0c6f4b5e6ac815e6b2d9d6cb2b.svg";
export { ForwardRef as ReactComponent };